import { Tabs } from '../components/Tabs';
import { Messages } from '../components/Messages/Messages';
import { LatestSongs } from '../components/Songs/LatestSongs';
import { LatestVideos } from '../components/Videos/LatestVideos';
import { LatestEvents } from '../components/Calendar/LatestEvents';
// import { Sidebar } from './components/Sidebar';

export const Home: React.FC = () => {
  const homePage = {
    tabs: ['Latest Videos', 'Latest Songs', 'Latest Events', 'Messages'],
    content: [
      <LatestVideos key={'latest-vids'} />,
      <LatestSongs key={'latest-songs'} />,
      <LatestEvents key={'latest-events'} />,
      <Messages key={'messages-component'} />,
      // <Search key={'search'} />
    ],
    modal: false,
  };

  {
    /* {user?.username ? <Sidebar /> : null} */
  }
  return (
    <div>
      <Tabs page={homePage} />
    </div>
  );
};
